import React from "react";
import { borderWidth, sizes, spacings } from "../../assets/themes";
import Block from "@/components/block";
import Skeleton from "@/components/skeleton";

const CategoriesNavigationSkeleton = () => (
  <Skeleton.Group>
    {new Array(8).fill("").map((_, i) => (
      <React.Fragment key={`edit-acc-skel-${i}`}>
        <Block alignItems="center" display="flex" marginY={spacings.m}>
          <Skeleton height={sizes.size48} rounded width={sizes.size48} />
          <Block
            alignItems="center"
            display="flex"
            flex={1}
            justifyContent="space-between"
            marginLeft={spacings.m}
          >
            <Skeleton height={sizes.size18} width={180} />
            <Skeleton height={sizes.size18} width={sizes.size18} />
          </Block>
        </Block>
        <Skeleton height={borderWidth.s} width="100%" />
      </React.Fragment>
    ))}
  </Skeleton.Group>
);

export default CategoriesNavigationSkeleton;
